export default __webpack_public_path__ + "static/media/somatorio_total.917d4017.svg";